import React, { useState, useEffect } from "react";
import { useParams, Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { getResortBySlug, getResorts } from "../service/service";
import { FaFacebookF, FaTwitter } from "react-icons/fa";
import { SearchContext } from "./Contexts/Context";
import { useContext } from "react";

function KhulosBuneba1() {
  const location = useLocation();
  const { id } = useParams();
  const [moreNews, setMoreNews] = useState({});
  const [exactNews, setExactNews] = useState({});
  const { language } = useContext(SearchContext);
  const [buneba, setBuneba] = useState({});
  const [moreBuneba, setMoreBuneba] = useState([]);

  useEffect(() => {
    const link = "https://khulo.gov.ge/api/news.php?lang=geo";
    fetch(link)
      .then((response) => response.json())
      .then((data) => {
        setExactNews(data["კურორტები და ღირსშესანიშნაობები"][id]);
        setMoreNews(data["კურორტები და ღირსშესანიშნაობები"]);
      });
  }, []);

  useEffect(() => {
    getResortBySlug(id).then((data) => {
      setBuneba(data);
    });
  }, [id]);

  const BunebaView = ({ buneba }) => {
    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div className="main-picture" style={{ marginRight: "20px" }}>
          <img src={buneba?.image} alt="" />
          {/* <span className="time">
                {language == 1 ? exactNews.geo.date : ""}
                {language == 2 ? exactNews.eng.date : ""}
              </span>
              <span className="header">
                {language == 1 ? exactNews.geo.title : ""}
                {language == 2 ? exactNews.eng.title : ""}
              </span> */}
        </div>
        <div className="main-content">
          <p
            style={{
              fontWeight: "bold",
              fontSize: "24px",
              marginBottom: "2px",
              marginLeft: "30px",
              marginTop: "10px",
            }}
          >
            {buneba?.name}
          </p>
          <span
            className="main-content-text"
            style={{ fontFamily: "Roboto, sans-serif" }}
            dangerouslySetInnerHTML={{
              __html: buneba?.description,
            }}
          ></span>

          <span>
            {" "}
            {language == 1 ? "   გააზიარე:" : ""}
            {language == 2 ? "SHARE:" : ""}
            {language == 3 ? "Поделиться:" : ""}
            <a
              href={`https://www.facebook.com/sharer.php?u=${window.location.href}`}
              rel="noreferrer"
              target="_blank"
            >
              <FaFacebookF />
            </a>
            <a
              href={`https://twitter.com/intent/tweet?url=${window.location.href}`}
              rel="noreferrer"
              target="_blank"
            >
              <FaTwitter />
            </a>
          </span>
        </div>
      </div>
    );
  };
  useEffect(() => {
    getResorts().then((data) => {
      setMoreBuneba(data);
    });
  }, []);

  const filterBuneba = moreBuneba.filter((buneba) => buneba.slug !== id);
  const BunebaMoreNews = () => {
    return (
      <>
        {filterBuneba.length == 0 ? (
          <div>Loading...</div>
        ) : (
          filterBuneba?.map((news, i) => (
            <Link to={`/geografia-da-buneba/${news?.slug}`} key={i}>
              <div key={news?.id} className="landing-items-container-infos">
                <div className="new-image-wrapper">
                  <img src={news?.image} alt={news?.title} />
                </div>
                <div>
                  <span className="header">{news?.name}</span>
                  <span className="vrclad">{"ვრცლად"}</span>
                </div>
              </div>
            </Link>
          ))
        )}
      </>
    );
  };
  // const newsList = Object.entries(moreNews).length
  //   ? Object.entries(moreNews)
  //       .reverse()
  //       .filter((news) => id !== news[0])
  //       .map((news, i) => {
  //         if (i <= 1) {
  //           return (
  //             <Link to={`/geografia-da-buneba/${news[0]}`}>
  //               <div
  //                 className="landing-items-container-infos"
  //                 id={news.id}
  //                 key={news.id}
  //               >
  //                 <div className="new-image-wrapper">
  //                   <img
  //                     src={
  //                       "https://khulo.gov.ge/" +
  //                       (news[1].geo.thumb_img
  //                         ? news[1].geo.thumb_img
  //                         : news[1].geo.img)
  //                     }
  //                     alt=""
  //                   />
  //                 </div>
  //                 <div>
  //                   <span className="time">
  //                     {language == 1 ? news[1].geo.date : ""}
  //                     {language == 2 ? news[1].eng.date : ""}
  //                     {language == 3 ? news[1].eng.date : ""}
  //                   </span>
  //                   <span className="header">
  //                     {language == 1 ? news[1].geo.title : ""}
  //                     {language == 2 ? news[1].eng.title : ""}
  //                     {language == 3 ? news[1].eng.title : ""}
  //                   </span>
  //                   <span className="vrclad">
  //                     <Link to={`/news/${news[0]}`}>
  //                       {language == 1 ? " ვრცლად" : ""}
  //                       {language == 2 ? " See more" : ""}
  //                       {language == 3 ? " увидеть все" : ""}
  //                     </Link>
  //                   </span>
  //                 </div>
  //               </div>
  //             </Link>
  //           );
  //         }
  //       })
  //   : "loading news";

  return (
    <motion.div
      intial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="news1-container margin-280px">
        <header>
          <span className="big" id="meria">
            {" "}
            {language == 1 ? "ხულო" : ""}
            {language == 2 ? "KHULO" : ""}
            {language == 3 ? "Хуло" : ""}
          </span>
          <span>
            {" "}
            {language == 1 ? "კურორტები და ღირსშესანიშნაობები" : ""}
            {language == 2 ? "RESORTS AND SIGHTS" : ""}
            {language == 3 ? "ГЕОГРАФИЯ И ПРИРОДА" : ""}
          </span>
        </header>
        <div className="main">
          {buneba.length === 0 ? (
            <div>Loading...</div>
          ) : (
            <BunebaView buneba={buneba} />
          )}

          <div className="moreNews">
            <span>
              {" "}
              {language == 1 ? "   სხვა ღირსშესანიშნაოებები:" : ""}
              {language == 2 ? "OTHER RESORTS AND SIGHTS:" : ""}
              {language == 3 ? "другие направления:" : ""}
            </span>
            <BunebaMoreNews />
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default KhulosBuneba1;
